module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/6-6a1910bd36d942d436560ae19c03c0fd.png";